<template>
  <main-template>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between align-center">
          <h1>
            <v-btn color="primary" x-small text @click="goBack">
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Justificativas em Massa
            <e-help-tooltip
              text="Justifique ausências de múltiplos colaboradores simultaneamente para uma mesma data de referência."
            />
          </h1>

          <v-btn color="primary" :to="{ name: 'colaboradores.justificativaMassa.nova' }">
            <v-icon left small>mdi-plus</v-icon>
            Nova Justificativa em Massa
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="justificativas"
              :loading="carregando"
              no-data-text="Nenhuma justificativa em massa cadastrada."
            >
              <template v-slot:item.data_referencia="{ item }">
                {{ formatarData(item.data_referencia) }}
              </template>

              <template v-slot:item.total_colaboradores="{ item }">
                <v-chip small color="info" outlined class="font-weight-bold">
                  {{ item.total_colaboradores || item.colaboradores_ids?.length || 0 }}
                  colaboradores
                </v-chip>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatarDataHora(item.created_at) }}
              </template>

              <template v-slot:item.acoes="{ item }">
                <v-btn icon small color="warning" class="mr-1" @click="editarJustificativa(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

                <v-btn icon small color="error" @click="confirmarExclusao(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de confirmação de exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="450px">
      <v-card>
        <v-card-title class="headline text-h6 red--text"
          >Excluir Justificativa em Massa?</v-card-title
        >
        <v-card-text>
          Tem certeza de que deseja remover esta justificativa coletiva? As ausências vinculadas
          serão desfeitas.
        </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn text @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn color="error" :loading="excluindo" @click="excluirJustificativa">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "JustificativaMassaPage",
  data() {
    return {
      carregando: false,
      justificativas: [],
      headers: [
        { text: "Data de Referência", value: "data_referencia" },
        { text: "Motivo", value: "motivo" },
        { text: "Impactados", value: "total_colaboradores" },
        { text: "Observação", value: "observacao" },
        { text: "Cadastrado Por", value: "criado_por_nome" },
        { text: "Data de Criação", value: "created_at" },
        { text: "Ações", value: "acoes", sortable: false, align: "right" },
      ],
      dialogExclusao: false,
      itemSelecionado: null,
      excluindo: false,
    };
  },
  mounted() {
    this.carregarLista();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async carregarLista() {
      try {
        this.carregando = true;
        const res = await this.$services.colaboradorPontosService.listarJustificativasMassa();
        this.justificativas = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    editarJustificativa(item) {
      this.$router.push({
        name: "colaboradores.justificativaMassa.nova",
        query: { id: item.id },
      });
    },
    confirmarExclusao(item) {
      this.itemSelecionado = item;
      this.dialogExclusao = true;
    },
    async excluirJustificativa() {
      if (!this.itemSelecionado) return;
      try {
        this.excluindo = true;
        await this.$services.colaboradorPontosService.excluirJustificativaMassa(
          this.itemSelecionado.id
        );
        this.dialogExclusao = false;
        this.carregarLista();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindo = false;
      }
    },
    formatarData(val) {
      if (!val) return "";
      const datePart = val.split("T")[0];
      const [ano, mes, dia] = datePart.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHora(val) {
      if (!val) return "";
      return new Date(val).toLocaleString("pt-BR");
    },
  },
};
</script>
